'use client';

import { VpIcon } from '@vtmn-play/react/headless';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { useAuthenticatedContext } from '@/app/components/Provider';
import { Avatar } from '~/components/commons/Avatar/Avatar';
import { useBreakpoint } from '~/hooks/match-media/useBreakpoint';
import { ProfilePictureDialog } from './ProfilePictureDialog';

export const ProfilePicture = () => {
  const t = useTranslations('PROFILE.PERSONAL_DATA');

  const { user } = useAuthenticatedContext();
  const { isSBreakpoint } = useBreakpoint();

  const [isEditing, setIsEditing] = useState(false);

  return (
    <div data-testid="profilePicture">
      <li className="vp-link-list__item">
        <button
          type="button"
          data-testid="edit-picture"
          name={t('CHANGE_AVATAR')}
          className="profile__avatar vp-link-list__item-link"
          onClick={() => setIsEditing(true)}
        >
          <div className="profile__link-list__item">
            <span className="profile__link-list__item__label">
              <Avatar user={user} avatarSize={48} />
              <span className="vp-subtitle-l">{user?.firstname}</span>
            </span>
          </div>
          <VpIcon name="chevron-right" size={20} />
        </button>
      </li>
      {isEditing && (
        <ProfilePictureDialog
          isSBreakpoint={isSBreakpoint}
          handleClose={() => setIsEditing(false)}
        />
      )}
    </div>
  );
};
